import { forwardRef } from "react";
import { API } from "@/lib/api";
import { Divider, Frame, STYLES, Wordmark } from "@/components/MenuOrnaments";

const dishes = (v) => v.split(/\n|;|•/).map((x) => x.replace(/^[-–*\s]+/, "").trim()).filter(Boolean);

export const MenuSheet = forwardRef(function MenuSheet({ art, info, logoOk, noLogo }, ref) {
  const s = STYLES[art.stile] || STYLES.classico;
  const secs = info.portate.map((p) => ({ ...p, titolo: art.sezioni[p.key] || p.label, righe: dishes(p.value) }));
  const lines = secs.reduce((n, p) => n + p.righe.length, 0);
  const brand = !noLogo && art.logo !== "none";
  const room = brand ? 200 : 240;
  const fs = Math.max(3, Math.min(7, room / (lines * 1.45 + secs.length * 4)));
  const caps = s.caps ? { fontVariant: "small-caps", letterSpacing: s.track ? "0.12em" : "0.03em" } : {};
  return (
    <div ref={ref} data-testid="menu-sheet" className="relative overflow-hidden" style={{ width: "210mm", height: "297mm", background: s.bg, color: s.text, fontFamily: s.body }}>
      <Frame stile={art.stile} />
      <div className="absolute inset-x-[22mm] top-[20mm] bottom-[18mm] flex flex-col items-center text-center" data-testid="menu-sheet-body">
        {brand && (logoOk ? <img src={`${API}/public/logo/${art.logo || info.logo}`} alt="logo" crossOrigin="anonymous" style={{ maxHeight: "24mm", maxWidth: "80mm", objectFit: "contain", flexShrink: 0 }} data-testid="menu-sheet-logo" /> : <Wordmark logo={art.logo || info.logo} color={s.title} w={62} />)}
        {art.titolo && <div style={{ fontFamily: s.head, color: s.title, fontSize: s.script ? "15mm" : "12mm", lineHeight: 1.1, marginTop: "3mm", fontWeight: s.script ? 400 : 600, ...(s.script ? {} : caps) }} data-testid="menu-sheet-title">{art.titolo}</div>}
        {art.sottotitolo && <div style={{ fontStyle: "italic", fontSize: "5mm", marginTop: "1mm", opacity: 0.85 }}>{art.sottotitolo}</div>}
        <div className="flex-1 w-full flex flex-col justify-evenly" style={{ marginTop: "2mm" }}>
          {secs.map((p) => (
            <div key={p.key} data-testid={`menu-sheet-section-${p.key}`}>
              <div style={{ fontFamily: s.head, color: s.title, fontSize: `${fs * (s.script ? 2.2 : 1.8)}mm`, lineHeight: 1.1, fontStyle: s.script || s.caps === false ? "normal" : "italic", fontWeight: s.script ? 400 : 600, ...(s.script ? {} : caps) }}>{p.titolo}</div>
              <Divider stile={art.stile} size={fs} />
              {p.righe.map((r, i) => <div key={i} style={{ fontSize: `${fs}mm`, lineHeight: 1.45, fontWeight: 500, ...caps }}>{s.caps ? r.toLowerCase() : r}</div>)}
            </div>
          ))}
        </div>
        {art.chiusura && <div style={{ fontSize: "4.4mm", marginTop: "3mm", maxWidth: "150mm", ...caps }} data-testid="menu-sheet-closing">{art.chiusura}</div>}
      </div>
    </div>
  );
});
